import {Component, signal} from '@angular/core';
import {MatSidenavModule} from '@angular/material/sidenav';
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {HeaderComponent} from './header/header.component';
import {LoadingComponent} from '@app/shared/loading/loading.component';
import {MatListModule} from '@angular/material/list';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [MatSidenavModule, MatListModule, RouterOutlet, RouterLink, RouterLinkActive, HeaderComponent, LoadingComponent],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
})
export class ShellComponent {
  menuItems = signal([
    {label: 'Dashboard', route: '/dashboard'},
    {label: 'Clients', route: '/clients'},
  ]);
}
